<template>
  <div class="content">
    <content-header title="商品の発送方法" />
    <div class="content-body">
      <p>
        お客様よりご注文いただきました商品は、下記の運送会社にてお届けいたします。
      </p>
      <p>
        「お届け先の変更」「配達日の日時指定」「指定時間を過ぎても商品が届かない」など配送に関するお問い合わせは、<br />
        メールに記載の「お問い合わせ送り状No.」をご確認のうえ、ヤマト運輸、または佐川急便お荷物問い合わせサービスまでお問い合わせください。
      </p>
      <div class="content-circle">
        ■ ヤマト運輸 :
        <a
          href="https://toi.kuronekoyamato.co.jp/cgi-bin/tneko"
          target="_blank"
        >
          お荷物お問い合わせサービス
          https://toi.kuronekoyamato.co.jp/cgi-bin/tneko
        </a>
        <br />
        ■ 佐川急便 :
        <a
          href="https://k2k.sagawa-exp.co.jp/p/sagawa/web/okurijoinput.jsp"
          target="_blank"
        >
          お荷物お問い合わせサービス
          https://k2k.sagawa-exp.co.jp/p/sagawa/web/okurijoinput.jsp
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/modules/ContentHeader'

export default {
  components: {
    ContentHeader,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/modules/guide/HowToShipping.vue